import {campaignAPI} from "../../services/api/campaignAPI";
import Vue from "vue";

const validators = {
  sms_content: {
    valid: (value) => typeof value === 'string' && value !== ''
  },
  item_name: {
    valid: (value) => typeof value === 'string' && value !== ''
  },
  expiration_date_local: {
    valid: (value) => !!value
  }
}

export const campaignValidator = {
  isValid(key, value) {
    const validator = validators[key];
    if (!validator) {
      throw new Error(`No validator found for ${key}`)
    }

    return validator.valid(value);
  },
  errors(data) {
    return Object.keys(validators).reduce((res, field) => res[field] = campaignValidator.isValid(field, data[field]), {});
  }
};

export const campaignModule = {
  state: () => ({
    campaign: null,
    touched: {},
    isValid: {},
    campaignNotificationTemplates: [],
    selectedNotificationTemplateId: null,
    selectedAutocampaignNotificationTemplates: {},
  }),
  getters: {
    campaign: (state) => state.campaign,
    selectedNotificationTemplateFor: (state) => (id) => {
      const templateId = state.selectedAutocampaignNotificationTemplates[id];
      return state.campaignNotificationTemplates.find((template) => template.id === templateId) || null;
    },
    hasError:(state) => (field) => {
      return !state.isValid[field] && state.touched[field];
    },
    campaignIsValid:(state) => {
      return Object.keys(validators).every((field) => state.isValid[field]);
    },
    campaignHasErrors:(state, getters) => {
      return Object.keys(validators).filter(getters.hasError).length > 0;
    },
    getCampaignNotificationTemplates: (state) => state.campaignNotificationTemplates
  },
  actions: {
    UPDATE_CAMPAIGN: async function({ state, commit }, frag) {
      const resp = await campaignAPI.patch(state.campaign.id, frag)
      commit('SET_CAMPAIGN', resp.campaign);
      commit('VALIDATE_FIELD', { field: 'sms_content', value: resp.campaign.sms_content });
      return resp.campaign;
    }
  },
  mutations: {
    SET_NOTIFICATION_TEMPLATES(state, templates) {
      state.campaignNotificationTemplates = templates || [];
    },

    SET_SELECTED_NOTIFICATION_TEMPLATE(state, { id, templateId }) {
      state.selectedAutocampaignNotificationTemplates = {
        ...state.selectedAutocampaignNotificationTemplates,
        [id]: templateId
      };
    },

    SET_CAMPAIGN(state, campaign) {
      state.campaign = campaign;
      Vue.set(state.isValid, 'sms_content', campaignValidator.isValid('sms_content', campaign.sms_content));
    },

    VALIDATE_FIELD(state, { field, value }) {
      Vue.set(state.isValid, field, campaignValidator.isValid(field, value));
    },

    TOUCHED_FIELD(state, field) {
      Vue.set(state.touched, field, new Date());
    }
  }
}
